import React, { useCallback, useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import api from '../../../../middleware/api';
import PortalModal from '../../../Common/Modal/PortalModal';
import { formatDefaultConfigurationToAddCapsule } from '../../../../utils/capsule_configuration.utils';
import { useCapsuleConfigurator } from '../../../../context/CapsuleConfiguratorContext';

const UpdateBatchDilutionModal = React.forwardRef(({ selectedItem, selectedConfigurationId, defaultCapsule, setCapsuleConfiguration }, ref) => {
    const [dilution, setDilution] = useState('');
    const [availableDilutions, setAvailableDilutions] = useState([]);
    const [loading, setLoading] = useState(true);
    const { updateConfigurationContent, setConfigurationSelection } = useCapsuleConfigurator();
    const handleDilutionChange = useCallback((value) => {
        setDilution(value);
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await api.put(`/capsules/configurations/update/batch/sensibility-dilution/${selectedConfigurationId}`, {
                mixtureIds: selectedItem,
                sensibility: null,
                dilution: availableDilutions.find(d => d.id === Number(dilution)) || null 
            });
            if (response.status === 200) {
                const updatedCapsule = formatDefaultConfigurationToAddCapsule(response.data.configuration, defaultCapsule.name, defaultCapsule.id);
                console.log('updatedCapsule', updatedCapsule)
                setCapsuleConfiguration(updatedCapsule);
                updateConfigurationContent(updatedCapsule.content)
                setConfigurationSelection({});
                toast.success('La dilution a été mise à jour avec succès');
            }
        } catch (e) {
            console.error(e);
            toast.error('Une erreur s\'est produite lors de la mise à jour de la dilution');
        }
        ref.current?.hideModal();
    }

    useEffect(() => {
        const fetchDilutions = async () => {
            try {
                const response = await api.get('/dilutions');
                if (response.status === 200) {
                    setAvailableDilutions(response.data.values);
                }
            } catch (e) {
                console.error(e);
                toast.error('Une erreur s\'est produite lors de la récupération des dilutions');
            } finally {
                setLoading(false);
            }
        };

        fetchDilutions();
    }, []);

    return (
        <PortalModal ref={ref}>
            <form onSubmit={handleSubmit} className='p-4'>
                <h1 className='text-xl font-bold mb-4'>Appliquer la dilution au mélanges sélectionnés</h1>

                <div className='flex flex-row flex-wrap gap-y-4 mt-4'>
                    <select
                        className='form-select border border-gray-300 rounded-md p-2'
                        onChange={(e) => handleDilutionChange(e.target.value)}
                        value={dilution}
                        disabled={loading}
                    >
                        <option value=''>Dilution</option>
                        {availableDilutions.map(dilution => (
                            <option key={dilution.id} value={dilution.id}>{dilution.label}</option>
                        ))}
                    </select>
                </div>
                <div className='flex flex-row flex-wrap justify-center gap-4 mt-4'>
                    <button 
                        type="submit" 
                        className='btn btn-primary max-w-24 min-w-24 rounded-md p-2'
                        disabled={loading}
                    >
                        Appliquer
                    </button>
                    <button 
                        type="button" 
                        className='btn btn-error text-white max-w-24 min-w-24 rounded-md p-2' 
                        onClick={() => ref.current?.hideModal()}
                    >
                        Annuler
                    </button>
                </div>
            </form>
        </PortalModal>
    );
});

export default UpdateBatchDilutionModal; 